module.exports = __webpack_public_path__ + "static/media/copy-2.6415e787.svg";